<nav class="flex flex-col gap-1 p-4">
  @if (authStore.isAuthenticated()) {
    @if (user(); as u) {
      <app-user-profile-link [user]="u" (clicked)="closeSidebar()" />
    }
    @if (switchableRoles().length > 1) {
      <app-role-selector
        [activeRole]="activeRole()"
        [switchableRoles]="switchableRoles()"
        (roleChange)="onRoleChange($event)"
      />
    }
    <div class="divider my-0"></div>
    @for (item of visibleMenuItems(); track item.title + (item.section ?? ''); let i = $index) {
      @if (item.section && (i === 0 || visibleMenuItems()[i - 1]?.section !== item.section)) {
        <div class="divider my-2 text-xs opacity-70">{{ item.section }}</div>
      }
      @if (item.routerLink) {
        <app-sidebar-nav-item
          [icon]="item.icon"
          [title]="item.title"
          [subtitle]="item.subtitle"
          [badge]="item.badge"
          [routerLink]="item.routerLink"
          (clicked)="closeSidebar()"
        />
      }
    }
    <app-sidebar-nav-item
      icon="log-out"
      title="Выйти"
      subtitle="Выйти из аккаунта"
      (clicked)="logout(); closeSidebar()"
    />
  } @else {
    @for (item of visibleGuestMenuItems(); track item.title) {
      <app-sidebar-nav-item
        [icon]="item.icon"
        [title]="item.title"
        [subtitle]="item.subtitle"
        [routerLink]="item.routerLink!"
        (clicked)="closeSidebar()"
      />
    }
  }
</nav>
